import { convertToTitleCase } from "../../../utils/helpers";
import { OPPORTUNITY_STATUS_COLORS, REQUEST_STATUS_COLORS } from "../../../store/admin/investorPortal/constants";
import {
  PRODUCT_STATUS_COLORS,
  STOCK_STATUS_COLORS,
  ORDER_STATUS_COLORS,
} from "../../../store/admin/marketplace/constants";
import {
  KYC_REVIEW_STATUS_COLORS,
  SERVICE_REQUEST_STATUS_COLORS,
  ACCOUNT_STATUS_COLORS,
} from "../../../store/admin/investorOperations/constants";

const DEFAULT_COLOR = "#A1A0A0";

export default function AdminStatusBadge({ status, colorMap, label }) {
  const normalized = String(status || "").toLowerCase();
  const colors = colorMap || REQUEST_STATUS_COLORS;
  const bg = colors[normalized] || DEFAULT_COLOR;
  const text = label || convertToTitleCase(normalized.replace(/_/g, " "));

  return (
    <span
      className="d-inline-block text-white rounded-pill px-3 py-1"
      style={{ fontSize: 12, fontWeight: 600, backgroundColor: bg, minWidth: 80, textAlign: "center" }}
    >
      {text}
    </span>
  );
}

export function OpportunityStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={OPPORTUNITY_STATUS_COLORS} />;
}

export function RequestStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={REQUEST_STATUS_COLORS} />;
}

export function KycStatusBadge({ status }) {
  const map = { none: "#A1A0A0", pending: "#FFA500", approved: "#19BC31", rejected: "#FF4343" };
  return <AdminStatusBadge status={status} colorMap={map} label={status === "approved" ? "Verified" : undefined} />;
}

export function ProductStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={PRODUCT_STATUS_COLORS} />;
}

export function StockStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={STOCK_STATUS_COLORS} />;
}

export function OrderStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={ORDER_STATUS_COLORS} />;
}

export function KycReviewStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={KYC_REVIEW_STATUS_COLORS} />;
}

export function ServiceRequestStatusBadge({ status }) {
  return <AdminStatusBadge status={status} colorMap={SERVICE_REQUEST_STATUS_COLORS} />;
}

export function InvestorAccountStatusBadge({ status }) {
  return (
    <AdminStatusBadge
      status={status}
      colorMap={ACCOUNT_STATUS_COLORS}
      label={status === "pending_verification" ? "Pending verification" : undefined}
    />
  );
}

export function ParticipantTypeBadge({ type }) {
  const isMember = type === "cooperative_member";
  return (
    <span
      className="d-inline-block rounded-pill px-2 py-1"
      style={{
        fontSize: 11,
        fontWeight: 600,
        backgroundColor: isMember ? "rgba(49, 119, 140, 0.12)" : "rgba(139, 49, 58, 0.1)",
        color: isMember ? "var(--color-secondary)" : "var(--color-primary)",
      }}
    >
      {isMember ? "Cooperative member" : "Standalone investor"}
    </span>
  );
}
